$(function ($) {

  /*---------------- Responsive Menu ------------------*/
  $(".nav-trigger").on('click', function (e) {
    $("body").toggleClass('off-canvas-body');
    $(".menu-bar").toggleClass("off-canvas");
    e.preventDefault();
  });
  $('.menu-bar').on("click", ".mega-dropdown > a > span", function (e) {
    $(this).parent().next('.menu-dropdown').slideToggle(600);
    $(this).toggleClass('ion-ios-arrow-down ion-ios-arrow-up');
    e.stopPropagation();
    e.preventDefault();
  });
  /*---------------- Responsive Menu ------------------*/

  $('.main-banner').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: true
  });

  /***************************************************/
  $('.customer-fav-slider-wrap').slick({
    autoplay: false,
    dots: false,
    arrows: true,
    centerMode: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
  /***************************************************/

  $('body').on('click', '.f-box .f-title', function() {
    $(this).toggleClass('open');
    $(this).closest('.f-box').children('.foot-col-data').slideToggle(600);
  });

  $(window).on('load',function() {
    equalheight('.product-title a');
    equalheight('.product-title');
  });

  $(window).on('resize',function() {
    equalheight('.product-title a');
    equalheight('.product-title');
  });

});